var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07573 8.77279L0.175729 4.87279C-0.0585762 4.63849 -0.0585762 4.25859 0.175729 4.02426L1.02424 3.17573C1.25854 2.9414 1.63846 2.9414 1.87277 3.17573L4.49999 5.80293L10.1272 0.175728C10.3615 -0.0585762 10.7414 -0.0585762 10.9758 0.175728L11.8243 1.02426C12.0586 1.25856 12.0586 1.63846 11.8243 1.87279L4.92426 8.77281C4.68993 9.00712 4.31003 9.00712 4.07573 8.77279Z",
    fill: "#017B5F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkbox-tick.21d06cf6344501bf3697421ab47ea2cc.svg";